import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";

const trackEvent = createTrackerForCategory(AmplitudeCategories.ModifyWorkspaceUsers);

enum events {
    InviteUsersStart = "InviteUsersStart",
    InviteUsersComplete = "InviteUsersComplete",
    ModifyUserRole = "ModifyUserRole",
    ModifyInviteRole = "ModifyInviteRole",
    QuantityContraction = "QuantityContraction",
    QuantityExpansion = "QuantityExpansion"
}

let _BillingControllerPromise: Promise<any>;
const getBillingController = () => {
    if (!_BillingControllerPromise) {
        // @ts-ignore
        _BillingControllerPromise = import("js/controllers/BillingController").then(module => module.default);
    }
    return _BillingControllerPromise;
};

export const ModifyWorkspaceUsers = {
    InviteUsersStart: async () => {
        const eventProperties = {
            quantity_seats_available: (await getBillingController()).availableSeatCount
        };

        trackEvent(events.InviteUsersStart, eventProperties, { audit: true });
    },

    InviteUsersComplete: (props: {
            quantity_invites_sent: number;
            quantity_new_seats_added: number;
            invite_ids: string[];
        }) => {
        trackEvent(events.InviteUsersComplete, props, { audit: true });
    },
    ModifyUserRole: (props: {affected_user_id: string, updated_role_from: string, updated_role_to: string}) => {
        trackEvent(events.ModifyUserRole, props, { audit: true });
    },
    ModifyInviteRole: (props: {affected_invite_id: string, updated_role_from: string, updated_role_to: string}) => {
        trackEvent(events.ModifyInviteRole, props, { audit: true });
    },
    QuantityContraction: (props: { quantity_seats_removed: number }) => {
        trackEvent(events.QuantityContraction, props, { audit: true });
    },
    QuantityExpansion: (props: { quantity_new_seats_added: number }) => {
        trackEvent(events.QuantityExpansion, props, { audit: true });
    }
};
